import GraphOutcomes from "./GraphOutcomes";

export default GraphOutcomes;